(function(){
  const modal   = document.getElementById('ab-qv-modal');
  const content = document.getElementById('ab-qv-content');

  // ---- Open in modal (popup) ----
  async function openQuickView(url){
    try{
      const res  = await fetch(url, { credentials:'same-origin' });
      const html = await res.text();
      if (!content || !modal) return;
      content.innerHTML = html;
      modal.showModal();
      trapFocus(modal);
      autoInit(); // inițializează caruselul din conținutul injectat
    }catch(err){
      console.error('QuickView error', err);
    }
  }

  // ---- Triggers (anchors & buttons) ----
  document.addEventListener('click', async (e) => {
    const a = e.target.closest('a.js-open-qv');
    if (!a) return;
    const url = a.getAttribute('href') || '';
    if (!/\?view=quick-(view|photos)/.test(url)) return;
    e.preventDefault();
    await openQuickView(url);
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button.js-open-qv');
    if (!btn) return;
    const url = btn.getAttribute('data-href') || '';
    if (!/\?view=quick-(view|photos)/.test(url)) return;
    e.preventDefault();
    await openQuickView(url);
  });

  // ---- Close modal + ESC ----
  if (modal && !modal.dataset.bound){
    modal.addEventListener('click', (e)=>{
      if (e.target.hasAttribute('data-ab-qv-close')) modal.close();
    });
    document.addEventListener('keydown', (e)=>{
      if (e.key === 'Escape' && modal.open) modal.close();
    });
    modal.dataset.bound = '1';
  }

  // ---- Focus trap minimal pentru <dialog> ----
  function trapFocus(dlg){
    const focusables = dlg.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const first = focusables[0], last = focusables[focusables.length - 1];
    dlg.addEventListener('keydown', (e)=>{
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last && last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first && first.focus(); }
    }, { once: true });
    (first || dlg).focus();
  }

  // ---- Carousel (arrows, dots, thumbs, swipe + ArrowKeys) ----
  function initCarousel(scope){
    const roots = scope.querySelectorAll('[data-carousel]');
    if (!roots.length) return;

    roots.forEach((root)=>{
      if (root.dataset.bound) return; // evit dublarea
      root.dataset.bound = '1';

      const viewport = root.querySelector('[data-viewport]');
      const slides   = Array.from(root.querySelectorAll('.ab-qv-carousel__slide'));
      const btnPrev  = root.querySelector('[data-prev]');
      const btnNext  = root.querySelector('[data-next]');
      const dotsWrap = root.querySelector('[data-dots]');
      const dots     = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.ab-qv-carousel__dot')) : [];
      const thumbsWrap = root.querySelector('[data-thumbs]');
      const thumbs     = thumbsWrap ? Array.from(thumbsWrap.querySelectorAll('.ab-qv-carousel__thumb')) : [];

      if (!viewport || !slides.length) return;

      let index = 0;
      const to = (i) => {
        index = Math.max(0, Math.min(i, slides.length - 1));
        viewport.scrollTo({ left: slides[index].offsetLeft, behavior:'smooth' });
        updateUI();
      };
      const next = () => to(index + 1);
      const prev = () => to(index - 1);

      function updateUI(){
        dots.forEach((d, i)=> d.classList.toggle('is-active', i === index));
        thumbs.forEach((t, i)=> t.classList.toggle('is-active', i === index));
      }

      // sincronizare la scroll manual
      let ticking = false;
      viewport.addEventListener('scroll', () => {
        if (ticking) return;
        window.requestAnimationFrame(() => {
          const pos = viewport.scrollLeft + viewport.clientWidth/2;
          const i = slides.findIndex(s => s.offsetLeft <= pos && (s.offsetLeft + s.clientWidth) >= pos);
          if (i >= 0 && i !== index){ index = i; updateUI(); }
          ticking = false;
        });
        ticking = true;
      }, { passive:true });

      btnPrev && btnPrev.addEventListener('click', prev);
      btnNext && btnNext.addEventListener('click', next);

      dots.forEach((d)=> d.addEventListener('click', ()=> to(parseInt(d.dataset.dot || '0', 10))));
      thumbs.forEach((t)=> t.addEventListener('click', ()=> to(parseInt(t.dataset.thumb || '0', 10))));

      // swipe simplu
      let startX = 0, pointerId = null;
      viewport.addEventListener('pointerdown', (e)=>{ startX = e.clientX; pointerId = e.pointerId; viewport.setPointerCapture(pointerId); });
      viewport.addEventListener('pointerup',   (e)=>{
        if (pointerId === null) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 40) (dx < 0 ? next() : prev());
        pointerId = null;
      });

      // navigare din tastatură (←/→) – funcționează în modal și în standalone
      const keyHandler = (e) => {
        const inModal = modal && modal.open;
        if (inModal || root.isConnected) {
          if (e.key === 'ArrowLeft')  prev();
          if (e.key === 'ArrowRight') next();
        }
      };
      document.addEventListener('keydown', keyHandler);

      // inițial
      updateUI();
    });
  }

  // ---- Public API ----
  function autoInit(){ initCarousel(document); }
  window.ABQuickView = window.ABQuickView || {};
  window.ABQuickView.open     = openQuickView;
  window.ABQuickView.autoInit = autoInit;

  // Dacă scriptul e încărcat pe o pagină care conține deja [data-carousel], pornește direct
  if (document.querySelector('[data-carousel]')) autoInit();
})();
